import { render } from "./index.vue?vue&type=template&id=05d58671&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=05d58671&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d58671"]])

export default __exports__